import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { withSnackbar } from "notistack";
import { v4 as uuidv4 } from "uuid";
import AlertDialog from "../../common/AlertDialog";
import { Box } from "@mui/material";
import ReactTooltip from "react-tooltip";

const ProcedureList = (props) => {
  const [page, setPage] = useState(0);
  const [openDeleteConfirmationDialogue, setOpenDeleteConfirmationDialogue] =
    useState(false);

  const ROWS_PER_PAGE = 8;
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * ROWS_PER_PAGE - props.procedures.length)
      : 0;
  const HEAD_COLUMNS = [
    "Edit",
    "Prefix",
    "Name",
    "Description",
    "Delete procedure",
  ]

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleCloseDeleteConfirmationDialogue = () => {
    setOpenDeleteConfirmationDialogue(false);
  };

  const handleEditProcedure = (data) => {
    props.handleOpenProcedureForm(data);
  };

  const handleDeleteProcedureClick = (data) => {
    props.handleSetContextProcedure(data);
    setOpenDeleteConfirmationDialogue(true);
  };

  const handleDeleteProcedure = () => {
    handleCloseDeleteConfirmationDialogue();
    props.handleDelete();
  };

  return (
    <>
     
      <Box>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer>
            <Table sx={{ minWidth: 750, color: "#fff" }}>
              <TableHead>
                <TableRow>
                  {HEAD_COLUMNS.map((heading) => (
                    <TableCell
                      style={{
                        backgroundColor: "black",
                        color: "#fff !important",
                      }}
                      key={uuidv4()}
                    >
                      {heading}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              {/*  */}

              <TableBody>
                {props.procedures
                  .slice(
                    page * ROWS_PER_PAGE,
                    page * ROWS_PER_PAGE + ROWS_PER_PAGE
                  )
                  .map((procedure, index) => (
                    <TableRow hover key={uuidv4()}>
                      <TableCell
                        align="center"
                        style={{ margin: 0, padding: 0 }}
                      >
                        <IconButton
                          onClick={() => handleEditProcedure(procedure)}
                        >
                          <EditIcon color="secondary" />
                        </IconButton>
                      </TableCell>

                      <TableCell component="th" scope="procedure">
                        {procedure.Prefix}
                      </TableCell>

                      <TableCell align="left">{procedure.Name}</TableCell>
                      
                      <TableCell align="left">
                        {procedure.Description}
                      </TableCell>

                      <TableCell align="center">
                        <IconButton
                          onClick={() => handleDeleteProcedureClick(procedure)}
                          variant="outlined"
                          color="primary"
                          title="Delete"
                          data-tip="Delete"
                        >
                          <ReactTooltip
                            place="top"
                            type="error"
                            effect="solid"
                          />

                          <DeleteIcon color="primary" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}

                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            rowsPerPageOptions={[ROWS_PER_PAGE]}
            rowsPerPage={ROWS_PER_PAGE}
            count={props.procedures.length}
            page={page}
            onPageChange={handleChangePage}
          />
        </Paper>
      </Box>
      {/* )} */}

      <AlertDialog
        open={openDeleteConfirmationDialogue}
        message={"Are you sure you want to delete this procedure ?"}
        handleClose={handleCloseDeleteConfirmationDialogue}
        handleDelete={handleDeleteProcedure}
      />
    </>
  );
};

export default withSnackbar(ProcedureList);
